import React, { useState } from 'react'
import WizardButton from '../components/WizardButton';
import { useDispatch, useSelector } from 'react-redux';
import { getWizardV2State } from '../wizardService';
import { setCapacityTooltip, setCurrentStep, setDataV2 } from '../onboardingSlice';
import { ONBOARDING_STEP_EVENT, ONBOARDING_PLUS_CLICKED, BIG_GROUP_CLICK } from '../../../constants/analyticEvents';
import { pushEvent } from '../../../utilities/analytics';
import { isMobile } from '../../../utilities/helpers';
import AdultsStepDesktop from '../../wizardDesktop/steps/AdultsStepDesktop';
import { t } from '../../../utilities/translator';
import GroupBookingBigGroup from '../../groupBooking/GroupBookingBigGroup';
import abTesting from '../../../services/abTesting';
import { BIG_GROUP_LINK } from '../../../constants/constants';

const AdultsStep = () => {
  const dispatch = useDispatch();
  const { formV2: form, step } = useSelector(state => state.onboarding);
  const [plusButtonClicked, setPlusButtonClicked] = useState(false);
  const data = getWizardV2State().whoStep;
  const { who } = form;
  const selectedType = who?.id;

  const allowBigGroupTxt = true;

  const onCardClick = (item) => () => {
    dispatch(setDataV2({ who: {
      ...who,
      capacity: {
        ...who?.capacity,
        adults: item,
      }
    } }));

    dispatch(setCapacityTooltip(false));

    pushEvent(ONBOARDING_STEP_EVENT, {
      step,
      stepName: selectedType === 'friends' ? 'friends' : 'adults',
      question: selectedType === 'friends' ? data.adultsSelection.friendsTitle : data.adultsSelection.familyTitle,
      selection: item,
      skipAvailable: !!(localStorage.getItem('onboardingCompleted')),
    });

    setTimeout(() => {
      dispatch(setCurrentStep(1))
    }, 500)
  }

  const onPlusClicked = () => {
    setPlusButtonClicked(true);
    pushEvent(ONBOARDING_PLUS_CLICKED, { type: 'adults' });
  };

  if (!isMobile()) {
    return (
      <AdultsStepDesktop
        form={form}
        selectedType={selectedType}
        onCardClick={onCardClick}
        plusButtonClicked={plusButtonClicked}
        onPlusClicked={onPlusClicked}
        data={data}
        onContinueClick={() => dispatch(setCurrentStep(1))}
        allowBigGroupTxt={allowBigGroupTxt}
      />
    )
  }

  return (
    <>
      <div className="wizard-step wizard-adults-step">
        <div className="wizard-step__title">{selectedType === 'friends' ? data.adultsSelection.friendsTitle : data.adultsSelection.familyTitle}</div>
        <div className={`wizard-step__options ${(selectedType === 'family') ? 'grid-cols-4' : 'grid-cols-3'}`}>
          {selectedType === 'family' && (
            <WizardButton
              label={1}
              className="slide-in-bottom animation-delay-0"
              active={form.who?.capacity?.adults === 1}
              onClick={onCardClick(1)}
            />
          )}
          <WizardButton
            label={2}
            className="slide-in-bottom animation-delay-100"
            active={form.who?.capacity?.adults === 2}
            onClick={onCardClick(2)}
          />
          <WizardButton
            label={3}
            className="slide-in-bottom animation-delay-200"
            active={form.who?.capacity?.adults === 3}
            onClick={onCardClick(3)}
          />
          {(selectedType === 'friends' || selectedType === 'family') && (
            <WizardButton
              label="+"
              className="slide-in-bottom animation-delay-300"
              onClick={() => onPlusClicked()}
              disabled={plusButtonClicked}
            />
          )}
        </div>
        {plusButtonClicked && !abTesting.groupBooking && (
          <div className="wizard-limit-message">
            {data.adultsSelection.moreThanAllowedText}
          </div>
        )}
        {(plusButtonClicked && allowBigGroupTxt && !abTesting.groupBooking) && (
          <div className="mt-10 p-3 rounded bg-info-light text-start scale-in-center">
            <p className="label-large leading-none mb-3 text-[15px]">{t('mainFilter.who.bigGroupTitle')}</p>
            <p className="body-medium font-medium mb-0" onClick={() => { pushEvent(BIG_GROUP_CLICK, { type: 'wizard' }); }} dangerouslySetInnerHTML={{ __html: t('mainFilter.who.bigGroupText', { link: BIG_GROUP_LINK }) }} />
          </div>
        )}
        {plusButtonClicked && abTesting.groupBooking && (
          <GroupBookingBigGroup />
        )}
      </div>
    </>
  )
}

export default AdultsStep
